export const routeNames = {
  login: 'login',
  dashboard: 'dashboard',
  termsAndConditions: 'termsAndConditions',
} as const